var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.375 8.75H2.0625V3.3125H0.375V8.75ZM1.21875 0.625C0.6875 0.625 0.25 1.0625 0.25 1.59375C0.25 2.125 0.6875 2.5625 1.21875 2.5625C1.75 2.5625 2.1875 2.125 2.1875 1.59375C2.1875 1.0625 1.75 0.625 1.21875 0.625ZM6.34375 3.1875C5.53125 3.1875 4.96875 3.625 4.75 4.0625H4.71875V3.3125H3.09375V8.75H4.78125V6.0625C4.78125 5.34375 4.90625 4.65625 5.78125 4.65625C6.65625 4.65625 6.65625 5.46875 6.65625 6.09375V8.75H8.375V5.78125C8.375 4.3125 8.0625 3.1875 6.34375 3.1875Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.60230d80f964c6f89a3a7c6637421890.svg";
export { ForwardRef as ReactComponent };